import logger from "../logger"

class WorkerQueue {
  constructor(workerGenerator) {
    this.tasks = []
    this.worker = null
    this.workerGenerator = workerGenerator
    this.lastRequestId = 0
  }

  startWorker() {
    let worker = this.workerGenerator()
    worker.onmessage = message => {
      let msg = message.data
      switch(msg.type) {
        case "ready" : return this.doNextTask()
        case "logs" :
          return logger.saveLog(...(msg.logs))
        case "response" :
          //setTimeout(() => {
            this.tasks[0].resolve(msg.result)
            this.tasks.shift()
            this.doNextTask()
          //}, 1500)
          break;
      }
    }
    worker.onerror = error => {
      this.tasks[0].reject(error)
      this.tasks.shift()
      worker.terminate()
      this.worker = null
      if(this.tasks.length > 0) {
        this.startWorker()
      }
    }
    this.worker = worker
  }
  doNextTask() {
    let nextTask = this.tasks[0]
    if(nextTask) {
      let { method, serializedArgs, requestId } = nextTask
      this.worker.postMessage({ type: "request", method, serializedArgs, requestId })
    }
  }
  doWorkerTask(method, serializedArgs) {
    let requestId = ++this.lastRequestId
    return new Promise((resolve, reject) => {
      let worker = this.worker
      this.tasks.push({ method, serializedArgs, resolve, reject, requestId })
      if(!worker) {
        this.startWorker()
        return;
      }
      if(this.tasks.length == 1) {
        worker.postMessage({ type: "request", method, serializedArgs, requestId })
      }
    })
  }
}

export default WorkerQueue



// WEBPACK FOOTER //
// ./src/io/WorkerQueue.js